import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../quote/quote.service';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { UserInfoService } from '../services/user-info.service';
import { LivestockService } from '../quote/livestock/livestock.service';
import { AmlineService } from '../quote/amline/amline.service';
import { BreakdownService } from '../quote/breakdown/breakdown.service';
import { ExcessProtectService } from '../quote/excess-protect/excess.service';
import { EquineService } from '../quote/equine/equine.service';
import { AgrimotorService } from '../quote/agrimotor/agrimotor.service';

@Component({
  selector: 'app-quote-pre-qualifier',
  templateUrl: './quote-pre-qualifier.component.html',
  styleUrls: ['./quote-pre-qualifier.component.css']
})
export class QuotePreQualifierComponent implements OnInit {
  public agreedQuestions;
  public ProductId: string = '';
  public routeType: number = 0;

  constructor(private quoteService: QuoteService, private route: ActivatedRoute, private router: Router,
    private userService: UserInfoService, private LvkService: LivestockService, private as: AmlineService,
    private breakdownService: BreakdownService,
    private excessprotectService: ExcessProtectService,
    private equineService: EquineService,
    private agrimotorService: AgrimotorService) {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      let url = event.url.split('/');
      this.routeType = parseInt(url[2]);
      this.getQuestions();
    });
  }


  ngOnInit(): void {
    // Number(), not the raw string param — getQuestions() switches on the numeric
    // value, so a string '11' fell through every case and left ProductId empty,
    // which meant the agreed-questions request was made against an empty product id.
    this.routeType = Number(this.route.snapshot.params.type);

    // Authenticate User
    this.userService.getUserDetails();

    // GET AGREED QUESTIONS
    this.getQuestions();
  }

  getQuestions() {
    switch (this.routeType) {
      case 1:
        this.ProductId = environment.EQUINE_ID;
        break;
      case 2:
        this.ProductId = environment.ALPACA_ID;
        break;
      case 3:
        this.ProductId = environment.LIVESTOCK_ID;
        break;
      case 4:
        this.ProductId = environment.ALLIANZ_EQUINE_ID;
        break;
      case 5:
        this.ProductId = environment.AJG_ID;
        break;
      case 6:
        this.ProductId = environment.AMLINE_ID;
        break;
      case 7:
        this.ProductId = environment.BREAKDOWN_ID;
        break;
      case 8:
        this.ProductId = environment.EXCESS_PROTECT_ID;
        break;
      case 9:
        this.ProductId = environment.SADDLERY_TACK_PROTECT_ID;
        break;
      case 10:
        this.ProductId = environment.NEW_EQUINE_ID;
        break;
      case 11:
        this.ProductId = environment.AGRIMOTOR_ID;
        break;
    }


    // GET QUOTE DETAILS
    if (this.routeType == 6) {
      if (this.route.snapshot.params.id) {
        this.as.getAmlineData(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              if (response.result) {
                this.getAgreedQuestions(response.result.quote_data.quote_versions[0].agreed_question_version);
              }
            });
      } else {
        this.getAgreedQuestions(0);
      }
    } else if (this.routeType == 7) {
      // Handling for Breakdown (type 7)
      // If we have a quote id
      if (this.route.snapshot.params.id) {
        let type = 0;
        if (this.route.snapshot.params.quote_type) {
          type = 1;
        }
        // Get our quote details by given id
        this.breakdownService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              if (response.success) {
                // Then get agreed questions upon successful retrieval
                this.getAgreedQuestions(response.result.agreed_question_version);

              }
            },
            (error) => {

            }
          );
      } else {
        // Otherwise we only get agreed questions
        this.getAgreedQuestions(0);
      }
    } else if (this.routeType == 8) {
      // Handling for Excess Protect (type 8)
      // If we have a quote id
      if (this.route.snapshot.params.id) {
        let type = 0;
        if (this.route.snapshot.params.quote_type) {
          type = 1;
        }
        // Get our quote details by given id
        this.excessprotectService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              if (response.success) {
                // Then get agreed questions upon successful retrieval
                this.getAgreedQuestions(response.result.agreed_question_version);

              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        // Otherwise we only get agreed questions
        this.getAgreedQuestions(0);
      }
    } else if (this.routeType == 9) {
      // Handling for Saddlery & Tack (type 9)
      // If we have a quote id
      if (this.route.snapshot.params.id) {
        let type = 0;
        if (this.route.snapshot.params.quote_type) {
          type = 1;
        }
        // Get our quote details by given id
        this.excessprotectService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              if (response.success) {
                // Then get agreed questions upon successful retrieval
                this.getAgreedQuestions(response.result.agreed_question_version);

              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        // Otherwise we only get agreed questions
        this.getAgreedQuestions(0);
      }
    } else if (this.routeType == 11) {
      // Handling for Agri Motor (type 11)
      if (this.route.snapshot.params.id) {
        this.agrimotorService.getAgrimotorData(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              // agreed_question_version lives on the quote version (as it does for
              // Amline), not on result itself — reading the wrong path produced an
              // `undefined` version and no questions at all.
              const version = response?.result?.quote_data?.quote_versions?.[0];
              this.getAgreedQuestions(version?.agreed_question_version
                ?? response?.result?.agreed_question_version ?? 0);
            },
            (error) => { this.getAgreedQuestions(0); }
          );
      } else {
        this.getAgreedQuestions(0);
      }
    } else if (this.routeType == 10) {
      // Handling for Equine (type 10)
      // If we have a quote id
      console.log('this.route.snapshot.params.id', this.route.snapshot.params.id);
      if (this.route.snapshot.params.id) {
        let type = 0;
        if (this.route.snapshot.params.quote_type) {
          type = 1;
        }
        // Get our quote details by given id
        this.equineService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id)
          .subscribe(
            (response: any) => {
              if (response.success) {
                // Then get agreed questions upon successful retrieval
                this.getAgreedQuestions(response.result.agreed_question_version);

              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        // Otherwise we only get agreed questions
        this.getAgreedQuestions(0);
      }
    } else {
      if (this.route.snapshot.params.type != 3) {
        if (this.route.snapshot.params.id) {
          let type = 0;
          if (this.route.snapshot.params.quote_type) {
            type = 1;
          }
          this.quoteService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id, type)
            .subscribe(
              (response: any) => {
                if (response.success) {
                  this.getAgreedQuestions(response.result.agreed_question_version);
                }
              },
              (error) => {
                ;
              }
            );
        } else {
          this.getAgreedQuestions(0);
        }
      }
      else {
        if (this.route.snapshot.params.id) {
          let type = 0;
          if (this.route.snapshot.params.quote_type) {
            type = 1;
          }
          this.LvkService.getQuoteDetailsByQuoteID(this.route.snapshot.params.id, type)
            .subscribe(
              (response: any) => {
                if (response.success) {
                  this.getAgreedQuestions(response.result.agreed_question_version);
                }
              },
              (error) => {
                ;
              }
            );
        }
        else {
          this.getAgreedQuestions(0);
        }
      }
    }
  }

  // Get Agreed Questions
  getAgreedQuestions(agreed_question_version: number): void {
    if (this.routeType == 7) {
      this.breakdownService.getAgreedQuestions(this.ProductId, agreed_question_version)
        .subscribe(
          (response: any) => {
            if (response.success) {
              const questions = response.result.agreed_questions;
              console.log('Questions: ', questions);
              this.agreedQuestions = questions.sort((curr, prev) => {return new Date(curr.created_at).getTime() - new Date(prev.created_at).getTime()});
              console.log('Sorted questions: ', this.agreedQuestions);
            }
          },
          (error) => {

          }
        );
    } else if (this.routeType == 8) {
      this.excessprotectService.getAgreedQuestions(this.ProductId, agreed_question_version)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.agreedQuestions = response.result.agreed_questions;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else if (this.routeType == 9) {
      this.excessprotectService.getAgreedQuestions(this.ProductId, agreed_question_version)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.agreedQuestions = response.result.agreed_questions;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else if (this.routeType == 10) {
      this.getStaticData();
    } else if (this.routeType == 11) {
      this.agrimotorService.getAgreedQuestions(this.ProductId, agreed_question_version)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.agreedQuestions = response.result.agreed_questions;
            }
          },
          (error) => { }
        );
    } else {
      this.quoteService.getAgreedQues(this.ProductId, agreed_question_version)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.agreedQuestions = response.result.agreed_questions;
            }
          },
          (error) => {

          }
        );
    }
  }

  public getStaticData() {
    this.equineService.getStaticData()
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.agreedQuestions = response.result.agreed_questions;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  /*
  * On Agree Button Click
  */
  agreedBtnAction() {
    if (this.route.snapshot.params.type == 1) {
      if (this.route.snapshot.params.id && !this.route.snapshot.params.quote_type) {
        this.router.navigate(['/quote', this.route.snapshot.params.id]);
      } else if (this.route.snapshot.params.quote_type) {
        this.router.navigate(['/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
      } else {
        this.router.navigateByUrl("/quote");
      }
    } else if (this.route.snapshot.params.type == 2) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/alpaca-admin/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/alpaca-admin/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/alpaca-admin/quote']);
      }
    } else if (this.route.snapshot.params.type == 3) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/livestock/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/livestock/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/livestock/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 4) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/allianz-equine/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/allianz-equine/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/allianz-equine/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 5) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/ajg/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/ajg/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/ajg/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 6) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/amline/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/amline/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/amline/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 7) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/breakdown/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/breakdown/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/breakdown/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 8) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/excess-protect/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/excess-protect/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/excess-protect/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 9) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/sdtk/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/sdtk/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/sdtk/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 10) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/equine/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/equine/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/equine/quote']);
      }
    }
    else if (this.route.snapshot.params.type == 11) {
      if (this.route.snapshot.params.id) {
        if (this.route.snapshot.params.quote_type) {
          this.router.navigate(['/agrimotor/quote', this.route.snapshot.params.id, this.route.snapshot.params.quote_type]);
        } else {
          this.router.navigate(['/agrimotor/quote', this.route.snapshot.params.id]);
        }
      } else {
        this.router.navigate(['/agrimotor/quote']);
      }
    }
  }

  /*
  * On Disagree Button Click - Navigate to home page
  */
  disagreeBtnAction() {
    this.router.navigateByUrl('/dashboard');
  }
  parseFinancialDeclaration(text: string): { header: string, points: string[] } {
    // Check if it contains the financial declaration
    if (!text.includes('Within the last 5 years, the proposer has not:')) {
      return null;
    }

    // Split by semicolons to get individual points
    const parts = text.split(';');

    // First part contains the header
    const headerPart = parts[0];
    const header = headerPart.substring(0, headerPart.indexOf(':') + 1).trim();

    // Get the first point from the header part
    const firstPoint = headerPart.substring(headerPart.indexOf(':') + 1).trim();

    // Get remaining points and clean them up
    const points = [firstPoint];
    for (let i = 1; i < parts.length; i++) {
      const point = parts[i].trim();
      if (point) {
        points.push(point);
      }
    }

    return { header, points };
  }
}
